/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreOverview } from './StoreOverview';
import {
    StoreOverviewFromJSON,
    StoreOverviewFromJSONTyped,
    StoreOverviewToJSON,
    StoreOverviewToJSONTyped,
} from './StoreOverview';
import type { StoreProfileChangeRequest } from './StoreProfileChangeRequest';
import {
    StoreProfileChangeRequestFromJSON,
    StoreProfileChangeRequestFromJSONTyped,
    StoreProfileChangeRequestToJSON,
    StoreProfileChangeRequestToJSONTyped,
} from './StoreProfileChangeRequest';

/**
 * 
 * @export
 * @interface StoreProfile
 */
export interface StoreProfile {
    /**
     * 
     * @type {string}
     * @memberof StoreProfile
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreProfile
     */
    published: boolean;
    /**
     * 
     * @type {string}
     * @memberof StoreProfile
     */
    url?: string;
    /**
     * 
     * @type {Date}
     * @memberof StoreProfile
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StoreProfile
     */
    updatedAt?: Date;
    /**
     * 
     * @type {StoreOverview}
     * @memberof StoreProfile
     */
    store: StoreOverview;
    /**
     * 
     * @type {StoreProfileChangeRequest}
     * @memberof StoreProfile
     */
    changeRequest?: StoreProfileChangeRequest;
}

/**
 * Check if a given object implements the StoreProfile interface.
 */
export function instanceOfStoreProfile(value: object): value is StoreProfile {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('published' in value) || value['published'] === undefined) return false;
    if (!('store' in value) || value['store'] === undefined) return false;
    return true;
}

export function StoreProfileFromJSON(json: any): StoreProfile {
    return StoreProfileFromJSONTyped(json, false);
}

export function StoreProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfile {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'published': json['published'],
        'url': json['url'] == null ? undefined : json['url'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'store': StoreOverviewFromJSON(json['store']),
        'changeRequest': json['changeRequest'] == null ? undefined : StoreProfileChangeRequestFromJSON(json['changeRequest']),
    };
}

export function StoreProfileToJSON(json: any): StoreProfile {
    return StoreProfileToJSONTyped(json, false);
}

export function StoreProfileToJSONTyped(value?: StoreProfile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'published': value['published'],
        'url': value['url'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'store': StoreOverviewToJSON(value['store']),
        'changeRequest': StoreProfileChangeRequestToJSON(value['changeRequest']),
    };
}

